const TourIcon = (props) => {
  return (
    <a className={`text-lg text-${props.color}`} onClick={props.startTour}>
      <i className="far fa-question-circle" />
    </a>
  );
};

export default TourIcon;
